import { DropdownInput } from '../../../baseInputs/DropdownInput';

interface TransitionInputProps {
  value?: string;
  onChange: (value?: string) => void;
}

export const TransitionInput = ({ value, onChange }: TransitionInputProps) => {
  return (
    <DropdownInput
      label="Transition"
      value={value}
      onChange={(newValue) => onChange(newValue?.toString())}
      options={[
        { value: 'none', label: 'None' },
        { value: 'all 0.3s ease', label: 'Ease' },
        { 
          value: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)', 
          label: 'Material' 
        },
        { 
          value: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)', 
          label: 'Bounce' 
        },
        { 
          value: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)', 
          label: 'Swiftly' 
        },
        { 
          value: 'all 0.3s cubic-bezier(0.68, -0.6, 0.32, 1.6)', 
          label: 'Elastic' 
        }
      ]}
      canBeCleared={false}
    />
  );
}; 